export default __webpack_public_path__ + "static/media/2016-AMcover.243d94f2.png";